import { Briefcase, Users, BarChart3, PlusCircle, LogOut, Settings } from "lucide-react";

const Sidebar = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: "stats", label: "الإحصائيات", icon: BarChart3 },
    { id: "add", label: "إضافة وظيفة", icon: PlusCircle },
    { id: "manage", label: "إدارة الوظائف", icon: Briefcase },
    { id: "applicants", label: "المتقدمين", icon: Users },
  ];

  const handleLogout = () => {
    // مسح التوكن من localStorage
    localStorage.removeItem("adminToken");
    // إعادة توجيه لصفحة Login
    window.location.href = "/admin/login";
  };

  return (
    <aside className="w-64 bg-gradient-to-b from-gray-900 to-slate-800 shadow-xl border-r border-gray-700 min-h-screen flex flex-col">
      {/* Header */}
      <div className="p-6 border-b border-gray-700">
        <h1 className="text-xl font-bold text-white text-center">لوحة التحكم</h1>
        <p className="text-sm text-gray-400 text-center mt-1">نظام إدارة الوظائف</p>
      </div>
      
      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`flex items-center w-full px-4 py-3 rounded-xl transition-all duration-300 group ${
              activeTab === id
                ? "bg-blue-600 text-white shadow-lg shadow-blue-600/25 transform scale-105"
                : "text-gray-300 hover:bg-gray-800 hover:text-white hover:shadow-md hover:transform hover:scale-105"
            }`}
          >
            <Icon className={`w-5 h-5 ml-3 transition-transform duration-300 ${
              activeTab === id ? "scale-110" : "group-hover:scale-110"
            }`} />
            <span className="font-medium">{label}</span>
            {activeTab === id && (
              <div className="w-1 h-6 bg-white rounded-full mr-auto ml-2"></div>
            )}
          </button>
        ))}
      </nav>

      {/* Footer with Logout */}
      <div className="p-4 border-t border-gray-700 space-y-2">
        {/* Settings Button (Optional) */}
        <button className="flex items-center w-full px-4 py-3 rounded-xl text-gray-300 hover:bg-gray-800 hover:text-white transition-all duration-300 group">
          <Settings className="w-5 h-5 ml-3 group-hover:rotate-90 transition-transform duration-300" />
          <span className="font-medium">الإعدادات</span>
        </button>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="flex items-center w-full px-4 py-3 rounded-xl text-gray-300 hover:bg-red-600 hover:text-white transition-all duration-300 group border border-transparent hover:border-red-500"
        >
          <LogOut className="w-5 h-5 ml-3 group-hover:rotate-180 transition-transform duration-300" />
          <span className="font-medium">تسجيل الخروج</span>
        </button>

        {/* User Info (Optional) */}
        <div className="pt-4 border-t border-gray-700">
          <div className="flex items-center px-2 py-2">
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
              <span className="text-white text-sm font-bold">أ</span>
            </div>
            <div className="mr-3">
              <p className="text-sm text-white font-medium">المسؤول</p>
              <p className="text-xs text-gray-400">Admin</p>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;